import { Injectable } from '@angular/core';

export interface StoredToken {
    id: string | number;
    token: string;
}

@Injectable({
    providedIn: 'root',
})
export class TokenStorage {
    private tokenKey = 'auth_token';

    signOut(): void {
        localStorage.removeItem(this.tokenKey);
    }

    saveToken(token: string, forUser: string): void {
        localStorage.setItem(this.tokenKey, JSON.stringify({ id: forUser, token: token }));
    }

    getTokenData(): StoredToken | null {
        const data = localStorage.getItem(this.tokenKey);
        if (!data) return null;
        try {
            const saved: unknown = JSON.parse(data);
            if (typeof saved !== 'object' || saved === null || !('id' in saved) || !('token' in saved)) return null;
            const { id, token } = saved;
            const validId = (typeof id === 'string' && !!id.trim()) || (typeof id === 'number' && Number.isFinite(id));
            if (validId && typeof token === 'string' && token.trim()) return { id: id as string | number, token };
        } catch {
            return null;
        }
        return null;
    }

    getTokenForHeader(): string | null {
        return this.getTokenData()?.token ?? null;
    }
}
